import { render, staticRenderFns } from "./SubscribeSuccess.vue?vue&type=template&id=50997533&scoped=true&"
import script from "./SubscribeSuccess.vue?vue&type=script&lang=js&"
export * from "./SubscribeSuccess.vue?vue&type=script&lang=js&"
import style0 from "./SubscribeSuccess.vue?vue&type=style&index=0&id=50997533&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50997533",
  null
  
)

export default component.exports